import { InviteStatus, PlaydateInvite, ResponseType } from "../../gql/types";
import { TagVariant } from "./InfoTag";

export const voteStatusTagComputer = (invite: PlaydateInvite): Array<{ label: string; variant: TagVariant }> => {
    const tags: Array<{ label: string; variant: TagVariant }> = [];

    const totalGuests = (invite.guests?.length ?? 0) + (invite.externalGuests?.length ?? 0);
    const responses = invite.responses || [];

    const respondedGuests = responses.filter(r => r !== null && r.responseType !== ResponseType.NoResponse).length;
    const rejectedGuests = responses.filter(r => r !== null && r.responseType === ResponseType.Reject).length;

    // Everyone rejected: all guests who responded have REJECT response
    if (totalGuests > 0 && rejectedGuests === totalGuests) {
        tags.push({
            label: "Everyone Declined",
            variant: TagVariant.DECLINED,
        });
    } else if (totalGuests > 0 && respondedGuests >= Math.ceil(totalGuests / 2) && invite.status === InviteStatus.InPlanning) {
        // Enough responses received: more than half of total guests have responded (accept, reject, or maybe)
        tags.push({
            label: "Finalize Invite",
            variant: TagVariant.ACTION_NEEDED,
        });
    }

    return tags;
};
